import React from 'react'

import { Car, type CarProps } from '@/components/atoms/Car/Car.tsx'
import { cn } from '@/lib/utils.ts'

export interface TeamMessagesStatusCardProps extends React.HtmlHTMLAttributes<HTMLDivElement> {
  car: Pick<CarProps, 'state' | 'carNumber' | 'carType'>
  count?: number
  hasUnreadMessages: boolean
}

export const TeamMessagesStatusCard = React.forwardRef<HTMLDivElement, TeamMessagesStatusCardProps>(
  ({ className, car, count, hasUnreadMessages, ...props }, ref) => (
    <div
      className={cn('flex items-center justify-between pt-[3px] pr-[6px] pb-[1px] pl-[12px]', className)}
      ref={ref}
      {...props}>
      <Car {...car} />
      <p className="text-gray-900 select-none">{count ? `(${count})` : ''}</p>
      <div className={cn('size-3 rounded-full', hasUnreadMessages ? 'bg-teal-400' : 'bg-transparent')} />
    </div>
  )
)
